(() => {
  if (customElements.get('aic-smart-cart')) return;
  const impressions = new Set();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const emit = (event, detail) => {
    document.dispatchEvent(new CustomEvent(`aic:smart-cart:${event}`, { detail }));
    if (!allowed()) return;
    try { window.Shopify?.analytics?.publish?.(`aic_smart_cart_${event}`, detail); } catch (_) {}
  };
  const details = card => ({
    version: 'v1', product_id: card.dataset.productId, variant_id: card.dataset.variantId,
    category: card.dataset.category, topic: card.dataset.topic,
    position: Number(card.dataset.position), placement: card.closest('aic-smart-cart')?.dataset.placement
  });
  class AicSmartCart extends HTMLElement {
    async connectedCallback() {
      if (this.hasAttribute('data-autoload')) {
        this.hidden = true;
        this.dataset.status = 'loading';
        try {
          const url = new URL(window.Shopify?.routes?.root || '/', location.origin);
          url.pathname += 'cart';
          url.searchParams.set('section_id', 'aic-cart-recommendations');
          if (this.dataset.themeId) url.searchParams.set('preview_theme_id', this.dataset.themeId);
          url.searchParams.set('_aic_cart', this.dataset.cartSignature);
          url.searchParams.set('_aic_refresh', String(Date.now()));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) { this.dataset.status = 'error-' + response.status; return; }
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.querySelector('aic-smart-cart');
          if (!this.isConnected) return;
          if (!result) { this.dataset.status = 'no-match'; return; }
          if (result.dataset.cartSignature !== this.dataset.cartSignature) { this.dataset.status = 'stale'; return; }
          // Each placement receives its own form ids, including the full cart page.
          result.querySelectorAll('form[id]').forEach(form => { form.setAttribute('id', form.getAttribute('id').replace('AicCart-drawer', 'AicCart-' + this.dataset.placement)); });
          this.innerHTML = result.innerHTML;
          this.hidden = false;
          this.dataset.status = 'ready';
        } catch (error) { this.dataset.status = 'error'; this.dataset.error = error.message; return; }
      }

      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting || entry.intersectionRatio < .5) continue;
          const drawer = this.closest('cart-drawer');
          if (drawer && !drawer.classList.contains('active')) continue;
          const key = `${this.dataset.cartSignature}:${entry.target.dataset.productId}`;
          if (impressions.has(key)) continue;
          impressions.add(key);
          emit('view', details(entry.target));
        }
      }, { threshold: .5 });
      this.watchCards = () => {
        this.observer.disconnect();
        this.querySelectorAll('[data-aic-card]').forEach(card => this.observer.observe(card));
      };
      this.watchCards();
      const drawer = this.closest('cart-drawer');
      if (drawer) {
        this.drawerObserver = new MutationObserver(this.watchCards);
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
      this.submitHandler = event => {
        const card = event.target.closest('[data-aic-card]');
        if (!card || !allowed()) return;
        for (const [name, value] of Object.entries({ _aic_cart_source: 'smart_cart_v1', _aic_cart_category: card.dataset.category })) {
          let input = event.target.querySelector(`[name="properties[${name}]"]`);
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; event.target.append(input); }
          input.value = value;
        }
      };
      this.addEventListener('submit', this.submitHandler, true);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.drawerObserver?.disconnect();
      this.removeEventListener('submit', this.submitHandler, true);
    }
  }
  customElements.define('aic-smart-cart', AicSmartCart);
  document.addEventListener('variant:add', event => {
    const card = event.detail?.formElement?.closest('[data-aic-card]');
    if (card) emit('add', details(card));
  });
})();

